import { Icon } from "react-migration/components/Icon";
import { Button } from "../Button";
import clsx from "clsx";

export interface PageControlsProps {
  page: number;
  totalPages: number;
  onPreviousPage: () => void;
  onNextPage: () => void;
  disabled?: boolean;
}

export const PageControls = ({ page, totalPages, disabled, onPreviousPage, onNextPage }: PageControlsProps) => {
  const isFirstPage = page === 1;
  const isLastPage = page === totalPages;

  return (
    <div
      className={clsx(
        "flex items-center select-none gap-x-1 h-9",
        "group-[.land-assembly-subselection-hide-page-controls]:hidden"
      )}
      data-testid="page-controls"
    >
      <Button variant="ghost" onClick={onPreviousPage} disabled={disabled || isFirstPage} className="md:w-9">
        <Icon size="md" icon="icon-lt-arrow-left-s-line" extraClasses="pointer-events-none" />
      </Button>
      <span className="text-xs md:text-sm text-blue-grey-950">
        {page}/{totalPages}
      </span>
      <Button variant="ghost" onClick={onNextPage} disabled={disabled || isLastPage} className="w-9">
        <Icon size="md" icon="icon-lt-arrow-right-s-line" extraClasses="pointer-events-none" />
      </Button>
    </div>
  );
};
